import { WorkflowPageDefinition } from "./WorkflowPageDefinition";

export class WorkflowDefinition {
    ID: number;
    Name: string;
    DefinitionDataOwners: number[];

    // This is only used onpage. The page definitions will be saved in the pages.
    PageDefinitions: WorkflowPageDefinition[];
}